export async function getLocation(): Promise<
  | {
      latitude?: number;
      longitude?: number;
      city?: string;
      region?: string;
      country?: string;
    }
  | undefined
> {
  // 1. Ask browser for coords
  const coords = await new Promise<{latitude: number; longitude: number} | null>(
    (resolve) => {
      if (!navigator.geolocation) return resolve(null);
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          resolve({latitude: pos.coords.latitude, longitude: pos.coords.longitude}),
        () => resolve(null),
        {enableHighAccuracy: true, timeout: 5000}
      );
    }
  );

  if (!coords) return undefined;

  // 2. Reverse-geocode to country / city / region
  try {
    const res = await fetch(
      `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coords.latitude}&longitude=${coords.longitude}&localityLanguage=en`
    );
    const data = await res.json();

    return {
      latitude: coords.latitude,
      longitude: coords.longitude,
      city: data.city || data.locality,
      region: data.principalSubdivision,
      country: data.countryName,
    };
  } catch {
    return {
      latitude: coords.latitude,
      longitude: coords.longitude,
    };
  }
}
